import {ChangeDetectionStrategy, Component, computed, inject} from '@angular/core';
import {BaseModalComponent} from "../../../../../../core/components/modals/base-modal/base-modal.component";
import {DatesCalculationsDialogData} from "./types/dates-calculations.types";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {MatButton} from "@angular/material/button";

@Component({
  selector: 'app-dates-calculations-modal',
  imports: [
    BaseModalComponent,
    MatButton
  ],
  templateUrl: './dates-calculations-modal.component.html',
  styleUrl: './dates-calculations-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DatesCalculationsModalComponent extends BaseModalComponent {
  private datesCalculationsDialogData = inject<DatesCalculationsDialogData>(MAT_DIALOG_DATA);

  public dates = computed(() => this.datesCalculationsDialogData.dates.dates);

  public override ngOnInit(): void {
    super.ngOnInit();
    this.modalStatesService.openModal(this.datesCalculationsDialogData.modalKey);
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.modalStatesService.closeModal(this.datesCalculationsDialogData.modalKey);
  }

  public getDisplayDate(date: string): string {
    return this.utilityService.formatDateToRussianStyle(new Date(date));
  }
}
